/**
 * Created by fuzhengsong on 2017/9/19.
 */
let restfull = '/';
let ns = 'api';

export default {
    restfull: restfull,
    ns: ns,
    wxsdk: '//res.wx.qq.com/open/js/jweixin-1.2.0.js',
    mta: {},
    base: __dirname,
    ravenJs: '',
    serverUrl: ''
};

export const defaultImage = {
    avatar: require('html/image/avatar.png'),
    cover: require('html/image/cover.jpg')
};

export const editorConfig = {
    toolbar: [
        'removeFormat', 'undo', '|', 'elements', 'fontName', 'fontSize', 'foreColor', 'backColor', 'divider',
        'bold', 'italic', 'underline', 'strikeThrough', 'links', 'divider', 'subscript', 'superscript',
        'divider', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', '|', 'indent', 'outdent',
        'insertOrderedList', 'insertUnorderedList', '|', 'picture', 'tables', '|', 'switchView'
    ],
    fontName: [
        {val: 'arial black'},
        {val: 'times new roman'},
        {val: 'Courier New'},
        {val: 'comic sans ms'},
        {val: '宋体'},
        {val: '楷体'},
        {val: '黑体'},
        {val: '隶书'},
        {val: '微软雅黑'}
    ],
    fontSize: [
        '12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px', '36px','48px','60px'
    ],
    uploadUrl: restfull + ns + '/common/upload',
    id: '',
    classList: ['vue-editor']
};



// WEBPACK FOOTER //
// ./src/config/config.test.js